import { VRegions, VGeos } from "../resources";
const isVRegion = (region) => VRegions.includes(region);
const isVGeo = (region) => VGeos.includes(region);
const LoggerPrefix = "[Regions-SDK]";
const logger = {
  log: (source, msg) => console.log(`${LoggerPrefix}[${source}] LOG: ${msg}`),
  warn: (source, msg) => console.warn(`${LoggerPrefix}[${source}] WARN: ${msg}`),
  error: (source, msg) => console.error(`${LoggerPrefix}[${source}] ERROR: ${msg}`),
  parseErrorMsg: (source, msg) => `${LoggerPrefix}[${source}] ERROR: ${msg}`
};
const generateScriptTag = (options) => {
  const { async = false, defer = false, attributes = {}, src, script, json } = options;
  if (!src && !script && !json) {
    throw new Error(logger.parseErrorMsg("generateScriptTag", "must define src, script or json"));
  }
  if (async && defer) {
    throw new Error(logger.parseErrorMsg("generateScriptTag", "both async and defer option is set to true"));
  }
  if (json && Object.keys(attributes).includes("id")) {
    throw new Error(logger.parseErrorMsg("generateScriptTag", "duplicated id found in both json and attributes"));
  }
  let tag = "<script";
  if (async) {
    tag += " async";
  }
  if (defer) {
    tag += " defer";
  }
  for (const [key, value] of Object.entries(attributes)) {
    tag += ` ${key}="${value}"`;
  }
  if (src) {
    tag += ` src="${src}"></script>`;
  } else if (script) {
    tag += `>${script}</script>`;
  } else if (json) {
    const jsonString = JSON.stringify(json.data);
    tag += ` type="application/json" id="${json.id}">${jsonString}</script>`;
  }
  return tag;
};
const isProd = () => process.env.NODE_ENV === "production";
export {
  generateScriptTag,
  isProd,
  isVGeo,
  isVRegion,
  logger
};

//# sourceMappingURL=shared.js.map